module.exports = __webpack_public_path__ + "static/media/routes10.df4c4996.webp";